(function () {
  if (customElements.get('fragrance-quiz')) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FAM = {
    fresh: { label: 'רענן', hint: 'הדרים, ים, כביסה נקייה', tone: '#cfe3df' },
    gourmand: { label: 'מתוק', hint: 'וניל, קרמל, קינוחים', tone: '#ead5b8' },
    woody: { label: 'עצי וחם', hint: 'עוד, ענבר, עור, טבק', tone: '#8a6a52' },
    floral: { label: 'פרחוני', hint: 'ורד, יסמין, פריחת תפוז', tone: '#e8c7c9' }
  };
  var QUESTIONS = [
    { key: 'gender', title: 'למי הבושם?', opts: [['women', 'לאישה'], ['men', 'לגבר'], ['any', 'לא משנה, גם יוניסקס']] },
    { key: 'fam', title: 'איזה ריח מושך אתכם?', hint: 'בחרו את הכיוון שהכי קרוב אליכם', blotter: true,
      opts: Object.keys(FAM).map(function (k) { return [k, FAM[k].label, FAM[k].hint]; }) },
    { key: 'occ', title: 'מתי תשתמשו בו?', opts: [['day', 'ביום־יום ובעבודה'], ['evening', 'בערב ובאירועים'], ['both', 'גם וגם']] },
    { key: 'buy', title: 'איך נוח לכם לקנות?', opts: [['decant', 'דיקנט קטן להתנסות'], ['bottle', 'בקבוק מלא מקורי'], ['inspired', 'בושם בהשראה, במחיר נמוך']] }
  ];

  var cache = {};
  function loadData(url) {
    if (cache[url]) return cache[url];
    cache[url] = (async function () {
      var get = async function (page) {
        var r = await fetch(url + '&page=' + page, { credentials: 'same-origin' });
        if (!r.ok) throw new Error('load');
        return JSON.parse(await r.text());
      };
      var first = await get(1), pages = Math.min(first.pages || 1, 10), rest = [];
      for (var p = 2; p <= pages; p++) rest.push(get(p));
      var more = await Promise.all(rest);
      return more.reduce(function (acc, j) { return acc.concat(j.products || []); }, first.products || []);
    })();
    cache[url].catch(function () { delete cache[url]; });
    return cache[url];
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(c) {
    var n = c / 100;
    return n.toLocaleString('he-IL', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' ₪';
  }
  function ml(t) {
    var m = String(t || '').match(/(\d+(?:\.\d+)?)\s*(?:מ["״'׳]?ל|ml)/i);
    return m ? parseFloat(m[1]) : null;
  }
  function isDecant(v) {
    var t = v.t || '';
    if (/דיקנט|decant|דוגמית|sample/i.test(t)) return true;
    var n = ml(t);
    return n !== null && n <= 30;
  }
  function isSampleProduct(p) {
    return p.s === 1 || /דוגמית|sample/i.test((p.ty || '') + ' ' + (p.t || ''));
  }
  function isInspired(p) {
    return /דיופ|בהשראה|dupe|inspired/i.test(p.ty || '') || !!(p.ib && String(p.ib).trim());
  }
  function genderOk(p, g) {
    var s = p.g || [];
    var has = function (x) { return s.indexOf(x) > -1; };
    if (g === 'women') return has('female') || (has('unisex') && !has('male'));
    if (g === 'men') return has('male') || (has('unisex') && !has('female'));
    return true;
  }
  function occInfo(p) {
    var o = p.o || [];
    return {
      day: o.indexOf('everyday') > -1 || o.indexOf('casual') > -1,
      eve: o.indexOf('special-occasion') > -1 || o.indexOf('formal') > -1
    };
  }
  function pick(p, buy, strict) {
    var av = p.vs || [];
    if (!av.length) return null;
    var smp = isSampleProduct(p), small = smp || /דיקנט|decant/i.test(p.ty || '');
    var dec = av.filter(function (v) { return small || isDecant(v); }).sort(function (a, b) { return a.p - b.p; });
    var full = small ? [] : av.filter(function (v) { return !isDecant(v); });
    var insp = isInspired(p);
    if (smp && buy !== 'decant') return null;
    if (buy === 'decant' && dec.length) return { v: dec[0], kind: smp ? 'sample' : 'decant', group: dec };
    if (buy === 'bottle' && !insp && full.length) return { v: full[0], kind: 'bottle', group: full };
    if (buy === 'inspired' && insp) return { v: full[0] || av[0], kind: 'inspired', group: [] };
    if (strict) return null;
    var v = dec[0] || full[0] || av[0], kd = isDecant(v);
    return { v: v, kind: insp ? 'inspired' : (small || kd ? 'decant' : 'bottle'), group: insp ? [] : (small || kd ? dec : full) };
  }

  function recommend(all, a, exclude) {
    var fams = a.fam || [];
    var base = all.filter(function (p) { return String(p.id) !== String(exclude) && genderOk(p, a.gender); });
    function score(p) {
      var s = 0, hits = 0, oi = occInfo(p);
      fams.forEach(function (f) { if ((p.f || []).indexOf(f) > -1) { s += 3; hits++; } });
      if (fams.length > 1 && hits === fams.length) s += 2;
      if ((a.occ === 'day' && oi.day) || (a.occ === 'evening' && oi.eve) || (a.occ === 'both' && oi.day && oi.eve)) s += 1;
      return { s: s, hits: hits };
    }
    var passes = [{ strict: true, needFam: true }, { strict: false, needFam: true }, { strict: false, needFam: false }];
    var chosen = [], used = {}, vendors = {};
    for (var i = 0; i < passes.length && chosen.length < 3; i++) {
      var ps = passes[i], cands = [];
      base.forEach(function (p, idx) {
        if (used[p.id]) return;
        var sc = score(p);
        if (ps.needFam && fams.length && !sc.hits) return;
        var pk = pick(p, a.buy, ps.strict);
        if (pk) cands.push({ p: p, pk: pk, s: sc.s, idx: idx });
      });
      cands.sort(function (x, y) { return (y.s - x.s) || (x.idx - y.idx); });
      [1, 2].forEach(function (round) {
        cands.forEach(function (c) {
          if (chosen.length >= 3 || used[c.p.id]) return;
          var vn = String(c.p.v || '').toLowerCase();
          if (round === 1 && vendors[vn]) return;
          chosen.push(c); used[c.p.id] = 1; vendors[vn] = 1;
        });
      });
    }
    return chosen;
  }

  function reasonLine(c, a) {
    var fl = (c.p.f || []).filter(function (f) { return FAM[f]; });
    var preferred = fl.filter(function (f) { return (a.fam || []).indexOf(f) > -1; });
    var show = (preferred.length ? preferred : fl).slice(0, 2).map(function (f) { return FAM[f].label; });
    var oi = occInfo(c.p), when = oi.day && oi.eve ? 'ליום ולערב' : oi.eve ? 'לערב ולאירועים' : oi.day ? 'ליום־יום' : '';
    var txt = show.join(' ו');
    if (when) txt += (txt ? ', מתאים ' : 'מתאים ') + when;
    return txt;
  }
  function kindLine(c) {
    if (c.pk.kind === 'sample') { var s = ml(c.pk.v.t) || ml(c.p.t); return s ? 'דוגמית רשמית ' + s + ' מ״ל' : 'דוגמית רשמית'; }
    if (c.pk.kind === 'decant') { var n = ml(c.pk.v.t); return n ? 'דיקנט ' + n + ' מ״ל' : 'דיקנט להתנסות'; }
    if (c.pk.kind === 'inspired') return c.p.ib ? 'בהשראת ' + String(c.p.ib).replace(/^\s*בהשראת\s*/, '') : 'בושם בהשראה';
    return 'בקבוק מלא';
  }

  class FragranceQuiz extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mode = this.dataset.mode || 'full';
      this.source = this.dataset.source || ROOT + 'collections/all';
      this.dataUrl = this.source + (this.source.indexOf('?') > -1 ? '&' : '?') + 'view=quiz-data&sort_by=best-selling&filter.v.availability=1';
      this.stage = this.querySelector('.fq-stage');
      this.dialog = this.querySelector('dialog');
      var self = this;
      var start = this.querySelector('[data-fq-start]');
      if (start) start.addEventListener('click', function () { self.begin(); });
      if (this.dialog) {
        this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.closeDialog(); });
        var x = this.dialog.querySelector('[data-fq-close]');
        if (x) x.addEventListener('click', function () { self.closeDialog(); });
      }
      this.stage.addEventListener('click', function (e) { self.onClick(e); });
      this.stage.addEventListener('pointermove', function () {
        var f = self.stage.querySelector('.fq-q[data-fresh]');
        if (f) f.removeAttribute('data-fresh');
      });
    }
    begin() {
      this.answers = {};
      if (this.dataset.preset) this.answers.gender = this.dataset.preset;
      this.steps = QUESTIONS.filter(function (q) { return !(q.key === 'gender' && this.answers.gender); }, this);
      this.step = 0;
      this.data = loadData(this.dataUrl);
      this.data.catch(function () {});
      if (this.dialog) { this.dialog.showModal(); }
      else { var intro = this.querySelector('.fq-intro'); if (intro) intro.hidden = true; this.stage.hidden = false; }
      this.renderQuestion();
    }
    closeDialog() { if (this.dialog && this.dialog.open) this.dialog.close(); }
    renderQuestion() {
      var q = this.steps[this.step], total = this.steps.length, sel = this.answers[q.key];
      var h = '<div class="fq-q" data-fresh data-key="' + q.key + '">';
      h += '<div class="fq-progress"><span>שאלה ' + (this.step + 1) + ' מתוך ' + total + '</span><i style="--fq-p:' + ((this.step + 1) / total) + '"></i></div>';
      h += '<h3 class="fq-q-title" tabindex="-1">' + esc(q.title) + '</h3>';
      if (q.hint) h += '<p class="fq-q-hint">' + esc(q.hint) + '</p>';
      h += '<div class="' + (q.blotter ? 'fq-blotters' : 'fq-opts') + '">';
      q.opts.forEach(function (o) {
        var on = Array.isArray(sel) ? sel.indexOf(o[0]) > -1 : sel === o[0];
        if (q.blotter) {
          h += '<button type="button" class="fq-blotter" data-val="' + o[0] + '" aria-pressed="' + on + '" style="--fq-tone:' + FAM[o[0]].tone + '">'
            + '<span class="fq-paper"><span class="fq-b-label">' + esc(o[1]) + '</span><span class="fq-b-hint">' + esc(o[2]) + '</span></span></button>';
        } else {
          h += '<button type="button" class="fq-opt" data-val="' + o[0] + '" aria-pressed="' + on + '">' + esc(o[1]) + '</button>';
        }
      });
      h += '</div><div class="fq-nav">';
      if (this.step > 0) h += '<button type="button" class="fq-link" data-fq-back>חזרה</button>';
      h += '</div></div>';
      this.stage.innerHTML = h;
      this._busy = false;
      var t = this.stage.querySelector('.fq-q-title');
      if (t && this._moved) t.focus({ preventScroll: true });
      this._moved = true;
    }
    onClick(e) {
      var b = e.target.closest('button');
      if (!b || !this.stage.contains(b)) return;
      if (b.hasAttribute('data-fq-back')) { this.step--; return this.renderQuestion(); }
      if (b.hasAttribute('data-fq-size')) return this.setSize(b);
      if (b.hasAttribute('data-fq-restart')) return this.begin();
      if (b.hasAttribute('data-fq-add')) return this.add([+b.dataset.fqAdd], b);
      if (b.hasAttribute('data-fq-add-all')) return this.add(this.results.map(function (c) { return c.pk.v.id; }), b);
      if (b.dataset.val && !this._busy) {
        var q = this.steps[this.step], self = this;
        this._busy = true;
        this.answers[q.key] = q.key === 'fam' ? [b.dataset.val] : b.dataset.val;
        this.stage.querySelectorAll('[data-val]').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
        var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(function () { self.next(); }, reduce ? 0 : (q.blotter ? 420 : 260));
      }
    }
    next() {
      if (this.step < this.steps.length - 1) { this.step++; return this.renderQuestion(); }
      this.showResults();
    }
    async showResults() {
      this.stage.innerHTML = '<p class="fq-status">מחפשים את ההתאמות שלכם…</p>';
      var all;
      try { all = await this.data; } catch (err) {
        this.stage.innerHTML = '<p class="fq-status">לא הצלחנו לטעון את הבשמים כרגע. רעננו את העמוד ונסו שוב.</p><div class="fq-nav"><button type="button" class="fq-link" data-fq-restart>להתחיל מחדש</button></div>';
        return;
      }
      var res = this.results = recommend(all, this.answers, this.dataset.exclude);
      if (!res.length) {
        this.stage.innerHTML = '<p class="fq-status">כרגע אין במלאי בשמים שמתאימים לבחירות האלה. נסו לשנות תשובה אחת.</p><div class="fq-nav"><button type="button" class="fq-link" data-fq-restart>להתחיל מחדש</button></div>';
        return;
      }
      var a = this.answers, total = 0;
      var h = '<div class="fq-results"><h3 class="fq-q-title" tabindex="-1">' + (res.length === 1 ? 'הניחוח שלכם' : 'הניחוחות שלכם') + '</h3><ul class="fq-cards">';
      res.forEach(function (c, i) {
        total += c.pk.v.p;
        var sizes = '';
        if (c.pk.group && c.pk.group.length > 1) {
          sizes = '<div class="fq-sizes" role="group" aria-label="בחירת נפח">' + c.pk.group.map(function (v, j) {
            var n = ml(v.t);
            return '<button type="button" class="fq-size" data-fq-size="' + i + ':' + j + '" aria-pressed="' + (v === c.pk.v) + '">' + esc(n ? n + ' מ״ל' : v.t) + '</button>';
          }).join('') + '</div>';
        }
        h += '<li class="fq-card" data-i="' + i + '"><a class="fq-card-img" href="' + esc(c.p.u) + '">' + (c.p.img ? '<img src="' + esc(c.p.img) + '" alt="' + esc(c.p.t) + '" loading="lazy" width="480" height="480">' : '') + '</a>'
          + '<p class="fq-card-vendor">' + esc(c.p.v) + '</p>'
          + '<a class="fq-card-name" href="' + esc(c.p.u) + '">' + esc(c.p.t) + '</a>'
          + '<p class="fq-card-why">' + esc(reasonLine(c, a)) + '</p>'
          + '<p class="fq-card-kind">' + esc(kindLine(c)) + '</p>'
          + sizes
          + '<p class="fq-card-price">' + money(c.pk.v.p) + '</p>'
          + '<button type="button" class="fq-btn fq-btn--line" data-fq-add="' + c.pk.v.id + '">הוספה לסל</button></li>';
      });
      h += '</ul><div class="fq-nav fq-nav--end">';
      if (res.length > 1) h += '<button type="button" class="fq-btn" data-fq-add-all>' + this.allLabel() + '</button>';
      h += '<button type="button" class="fq-link" data-fq-restart>להתחיל מחדש</button></div><p class="fq-msg" role="status"></p></div>';
      this.stage.innerHTML = h;
      var t = this.stage.querySelector('.fq-q-title');
      if (t) t.focus({ preventScroll: true });
    }
    allLabel() {
      var res = this.results || [], total = res.reduce(function (s, c) { return s + c.pk.v.p; }, 0);
      return 'להוסיף את ' + (res.length === 3 ? 'שלושתם' : 'שניהם') + ' לסל (' + money(total) + ')';
    }
    setSize(b) {
      var ij = b.dataset.fqSize.split(':'), c = this.results[+ij[0]], v = c && c.pk.group[+ij[1]];
      if (!v) return;
      c.pk.v = v;
      var card = this.stage.querySelector('.fq-card[data-i="' + ij[0] + '"]');
      card.querySelectorAll('.fq-size').forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      card.querySelector('.fq-card-kind').textContent = kindLine(c);
      card.querySelector('.fq-card-price').textContent = money(v.p);
      var add = card.querySelector('[data-fq-add]');
      add.setAttribute('data-fq-add', v.id); add.disabled = false; add.textContent = 'הוספה לסל';
      var all = this.stage.querySelector('[data-fq-add-all]');
      if (all) { all.textContent = this.allLabel(); all.disabled = false; }
    }
    async add(ids, btn) {
      var label = btn.textContent, self = this;
      btn.disabled = true; btn.textContent = 'מוסיפים…';
      try {
        var r = await fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1, properties: { _source: 'fragrance-quiz' } }; }) })
        });
        if (!r.ok) throw new Error('add');
        btn.textContent = 'נוסף לסל';
        var drawer = document.querySelector('m-cart-drawer');
        if (drawer && window.MinimogSettings && MinimogSettings.enable_cart_drawer && drawer.onCartDrawerUpdate) {
          self.closeDialog();
          drawer.onCartDrawerUpdate();
          setTimeout(function () { drawer.open(); }, 300);
        } else {
          window.location.href = ROOT + 'cart';
        }
      } catch (err) {
        btn.disabled = false; btn.textContent = label;
        var m = this.stage.querySelector('.fq-msg');
        if (m) m.textContent = 'לא הצלחנו להוסיף לסל. נסו שוב.';
      }
    }
  }
  customElements.define('fragrance-quiz', FragranceQuiz);
})();
